import NotesPasswordRegistrationDialog from './container'
export { NotesPasswordRegistrationDialog }
export default NotesPasswordRegistrationDialog